import { upcomingSummerYear } from '@leangap/types/utils/date'

export const APP_TITLE_BASE = 'Apply to Leangap'

/**
 * Title for the current application cycle, e.g. "Apply to Leangap | Summer 2027".
 * The year advances on September 1 so it never has to be updated by hand.
 */
export function getAppTitle() {
	return `${APP_TITLE_BASE} | Summer ${upcomingSummerYear()}`
}

export function applyAppTitle() {
	document.title = getAppTitle()
}
